export default [
  { value: "All", key: -999 },
  { value: "Banned", key: -2 },
  { value: "Suspended", key: -1 },
  { value: "Active", key: 0 },
];
